module.exports = __webpack_public_path__ + "img/available.f122e0dc.svg";